<div class="d-flex">
    <button kendoButton
            (click)="onDelete()"
            icon="trash"
            class="align-self-end">
    </button>
    <div class="flex-grow-1"
         style="display: grid; grid-template-columns: repeat(4, 1fr); grid-template-rows: auto; gap: 12px;">
        <kendo-label text="Cargo name"
                     [class.text-grey]="valid().cargoTypeId"
                     [class.text-red]="!valid().cargoTypeId">
            <kendo-combobox [data]="cargoTypes()"
                            [value]="cargo().cargoTypeId"
                            (valueChange)="onCargoTypeChange($event)"
                            [valuePrimitive]="true"
                            [textField]="'name'"
                            [valueField]="'id'"
                            [clearButton]="false"
                            [placeholder]="'-'"
                            [virtual]="true"
                            [popupSettings]="{ width: 'auto'}"
                            [fillMode]="'outline'"
                            [class.border-red]="!valid().cargoTypeId">
            </kendo-combobox>
        </kendo-label>
        <kendo-label text="Unit"
                     [class.text-grey]="valid().unitId"
                     [class.text-red]="!valid().unitId">
            <kendo-combobox [data]="cargoUnitTypes()"
                            [value]="cargo().unitId"
                            (valueChange)="onCargoUnitChange($event)"
                            [valuePrimitive]="true"
                            [textField]="'name'"
                            [valueField]="'id'"
                            [clearButton]="false"
                            [placeholder]="'-'"
                            [virtual]="true"
                            [popupSettings]="{ width: 'auto'}"
                            [fillMode]="'outline'"
                            [class.border-red]="!valid().unitId">
            </kendo-combobox>
        </kendo-label>
        <kendo-label text="Quantity"
                     [class.text-grey]="valid().quantity"
                     [class.text-red]="!valid().quantity">
            <kendo-numerictextbox [spinners]="false"
                                [value]="cargo().quantity"
                                (valueChange)="onCargoQuantityChange($event)"
                                [fillMode]="'outline'"
                                [placeholder]="'-'"
                                [class.border-red]="!valid().quantity">
            </kendo-numerictextbox>
        </kendo-label>
        <kendo-label text="Cargo operation"
                     [class.text-grey]="valid().cargoOperationTypeId"
                     [class.text-red]="!valid().cargoOperationTypeId">
            <kendo-combobox [data]="cargoOperations()"
                            [value]="cargo().cargoOperationTypeId"
                            (valueChange)="onCargoOperationChange($event)"
                            [valuePrimitive]="true"
                            [textField]="'name'"
                            [valueField]="'id'"
                            [clearButton]="false"
                            [placeholder]="'-'"
                            [virtual]="true"
                            [popupSettings]="{ width: 'auto'}"
                            [fillMode]="'outline'"
                            [class.border-red]="!valid().cargoOperationTypeId">
            </kendo-combobox>
        </kendo-label>
    </div>

</div>